/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (node: BaseFeature): CodeBlock[] => {
    let blocks: CodeBlock[] = [];
    const project = node.project;

    const vars = node.getSettingValue('VARS').concat(node.getSettingValue('AUTOVARS'));
    const TIMER_NAME = 'var_poll_timer';
    const INTERVAL = Number(node.getSettingValue('INTERVAL')) * 1000;

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `declare ${TIMER_NAME} as dword`,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `dim ${TIMER_NAME} as dword`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
${TIMER_NAME} = ${INTERVAL}`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
def var_poll_timer():
    while True:
        try:
            #****var_poll_timer_elapsed****#
            pass
        except Exception as e:
            
            pass
        await asyncio.sleep_ms(100)`,
    });

    blocks.push({
        location: 'ASYNC_TASKS',
        blockType: BlockType.CODE,
        template: `
var_loop = asyncio.get_event_loop()
var_loop.create_task(var_poll_timer())`,
    });

    for (let i = 0; i < vars.length; i += 1) {
        blocks = blocks.concat(vars[i].getCodeBlocks());
    }

    return blocks;
};
